import React from 'react'
import { Grid } from '@mui/material'
import i18n from 'simple-react-i18n'

const StatisticalIndicatorsLegend = () => {
    return (
        <Grid container>
            <Grid size={12}>
                <span className='red arrests-level-panel red-text'>O</span> {i18n.monthlyMin}
            </Grid>
            <Grid size={12}>
                <span className='blue arrests-level-panel blue-text'>O</span> {i18n.monthlyMax}
            </Grid>
            <Grid size={12}>
                <span className='orange arrests-level-panel orange-text'>O</span> {i18n.statistics}
            </Grid>
        </Grid>
    )
}

export default StatisticalIndicatorsLegend;
